/**
 * 교과세특 독서활동 추천 - SEO 롱테일 페이지
 * 
 * 타겟 키워드: 교과세특 독서활동, 세특 독서, 생기부 독서 추천, 과목별 추천도서
 */

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Footer from '../../components/layout/Footer';
import '../../styles/design-system/index.css';

const DokseoGuidePage = () => {
  const navigate = useNavigate();
  const [selectedSubject, setSelectedSubject] = useState('통합과학');

  const subjects = ['통합과학', '생명과학', '물리학', '화학', '통합사회', '경제', '국어', '영어', '수학'];

  const bookRecommendations = {
    '통합과학': [
      { title: '코스모스', author: '칼 세이건', level: '중', connection: '우주와 생명의 기원, 과학적 탐구 방법론', setak: '「코스모스」를 읽고 우주의 광대함 속에서 지구 생명체의 존재 의미를 탐구함. 특히 드레이크 방정식을 통해 외계 생명체 존재 가능성을 수학적으로 접근하는 과정에서 과학적 사고력을 키움.' },
      { title: '이기적 유전자', author: '리처드 도킨스', level: '상', connection: '진화론, 유전과 생명 현상', setak: '「이기적 유전자」를 통해 진화의 단위가 개체가 아닌 유전자라는 관점을 학습함. 이타적 행동의 유전적 기반을 이해하며 생명 현상을 새로운 시각으로 바라보게 됨.' },
      { title: '파인만의 물리학 강의', author: '리처드 파인만', level: '상', connection: '물리학 원리, 과학적 사고', setak: '「파인만의 물리학 강의」를 읽고 일상에서 관찰되는 현상의 물리적 원리를 탐구함. 특히 빛의 이중성에 대한 설명을 통해 양자역학의 기초 개념을 이해함.' }
    ],
    '생명과학': [
      { title: '이중나선', author: '제임스 왓슨', level: '중', connection: 'DNA 구조 발견, 과학 연구 과정', setak: '「이중나선」을 통해 DNA 구조 발견 과정을 생생하게 접함. 과학적 발견이 경쟁과 협력 속에서 이루어지는 모습을 보며 과학 연구의 현실적 측면을 이해함.' },
      { title: '침묵의 봄', author: '레이첼 카슨', level: '중', connection: '생태계, 환경과 생명의 상호작용', setak: '「침묵의 봄」을 읽고 농약이 생태계에 미치는 영향을 학습함. 생물농축 현상과 먹이사슬의 연결고리를 이해하며 환경보전의 중요성을 깨달음.' },
      { title: '이타적 유전자', author: '매트 리들리', level: '상', connection: '유전과 환경, 본성과 양육', setak: '「이타적 유전자」를 통해 유전자와 환경의 상호작용을 탐구함. 인간 행동이 유전과 환경 모두의 영향을 받는다는 점을 이해하며 생명과학적 관점을 확장함.' }
    ],
    '물리학': [
      { title: '시간의 역사', author: '스티븐 호킹', level: '상', connection: '우주론, 시공간의 물리학', setak: '「시간의 역사」를 읽고 블랙홀과 빅뱅 이론을 탐구함. 특히 사건의 지평선 개념을 통해 시공간의 왜곡 현상을 이해하고 상대성 이론에 대한 관심을 키움.' },
      { title: '엘러건트 유니버스', author: '브라이언 그린', level: '상', connection: '끈이론, 현대 물리학', setak: '「엘러건트 유니버스」를 통해 끈이론의 기본 개념을 학습함. 4개 이상의 차원이 존재할 수 있다는 가능성에 흥미를 느끼며 이론물리학에 대한 관심을 키움.' }
    ],
    '화학': [
      { title: '사라진 스푼', author: '샘 킨', level: '중', connection: '원소와 주기율표, 화학의 역사', setak: '「사라진 스푼」을 읽고 각 원소의 발견 과정과 특성을 흥미롭게 학습함. 주기율표가 단순한 암기 대상이 아닌 원소들의 체계적 분류임을 이해함.' },
      { title: '앵무새와 녹나무', author: '로알드 호프만', level: '상', connection: '분자 구조, 화학의 아름다움', setak: '「앵무새와 녹나무」를 통해 분자 구조의 심미적 아름다움을 느낌. 화학이 단순한 반응식이 아닌 자연의 예술임을 깨달으며 학문에 대한 열정을 키움.' }
    ],
    '통합사회': [
      { title: '정의란 무엇인가', author: '마이클 샌델', level: '중', connection: '윤리학, 정의의 개념', setak: '「정의란 무엇인가」를 읽고 공리주의, 자유주의, 공동체주의 관점에서 정의를 탐구함. 트롤리 딜레마를 통해 도덕적 판단의 복잡성을 이해함.' },
      { title: '총, 균, 쇠', author: '재레드 다이아몬드', level: '상', connection: '세계사, 문명 발전의 요인', setak: '「총, 균, 쇠」를 통해 문명 발전의 지리적·환경적 요인을 분석함. 역사가 개인의 능력보다 환경적 조건에 의해 좌우될 수 있음을 이해함.' }
    ],
    '경제': [
      { title: '국부론', author: '애덤 스미스', level: '상', connection: '고전 경제학, 시장경제의 원리', setak: '「국부론」을 읽고 보이지 않는 손의 개념을 학습함. 개인의 이익 추구가 사회 전체의 이익으로 이어지는 시장 메커니즘을 이해함.' },
      { title: '죽은 경제학자의 살아있는 아이디어', author: '토드 부크홀츠', level: '중', connection: '경제학사, 다양한 경제 이론', setak: '「죽은 경제학자의 살아있는 아이디어」를 통해 경제학의 발전 과정을 학습함. 케인즈와 하이에크의 논쟁을 통해 경제 정책의 다양한 관점을 이해함.' }
    ],
    '국어': [
      { title: '데미안', author: '헤르만 헤세', level: '중', connection: '자아 정체성, 성장 소설', setak: '「데미안」을 읽고 청소년기 자아 정체성 탐색 과정을 문학적으로 이해함. 싱클레어의 성장 과정에서 자신의 모습을 투영하며 깊은 공감을 느낌.' },
      { title: '1984', author: '조지 오웰', level: '중', connection: '디스토피아, 사회 비판', setak: '「1984」를 통해 전체주의 사회의 위험성을 탐구함. 빅브라더와 이중사고 개념을 현대 사회의 미디어 통제와 연결하여 비판적 시각을 기름.' }
    ],
    '영어': [
      { title: 'The Great Gatsby', author: 'F. Scott Fitzgerald', level: '상', connection: '미국 문학, 아메리칸 드림', setak: 'The Great Gatsby를 원서로 읽으며 1920년대 미국 사회와 아메리칸 드림의 허상을 탐구함. 상징과 은유를 분석하며 문학적 영어 표현력을 향상시킴.' },
      { title: 'Animal Farm', author: 'George Orwell', level: '중', connection: '우화, 정치 비판', setak: 'Animal Farm을 원서로 읽고 우화를 통한 정치 비판의 효과를 학습함. 영어 원문의 풍자적 표현을 분석하며 영문학에 대한 이해를 깊이함.' }
    ],
    '수학': [
      { title: '수학의 확실성', author: '모리스 클라인', level: '상', connection: '수학의 본질, 수학사', setak: '「수학의 확실성」을 읽고 수학이 절대적 진리인지 탐구함. 비유클리드 기하학의 등장으로 수학의 토대가 흔들린 역사를 통해 학문의 발전 과정을 이해함.' },
      { title: '페르마의 마지막 정리', author: '사이먼 싱', level: '중', connection: '수학사, 문제 해결 과정', setak: '「페르마의 마지막 정리」를 통해 350년간 풀리지 않던 수학 문제가 해결되는 과정을 흥미롭게 학습함. 수학자들의 끈질긴 도전 정신에서 배움의 자세를 깨달음.' }
    ]
  };

  const currentBooks = bookRecommendations[selectedSubject];

  return (
    <>
      <Helmet>
        <title>교과세특 독서활동 추천 | 과목별 추천도서 & 세특 연계 문장 (2026)</title>
        <meta name="description" content="교과세특 독서활동 추천도서 모음. 통합과학, 생명과학, 물리, 화학, 사회, 경제, 국어, 영어, 수학 과목별 추천도서와 세특 연계 문장 예시. AI로 독서활동 세특 자동 생성." />
        <meta name="keywords" content="교과세특 독서활동, 세특 독서, 생기부 독서 추천, 과목별 추천도서, 세특 도서, 독서활동 세특 예시, 독서활동 기재" />
        <link rel="canonical" href="https://whatquiz.co.kr/guide/dokseo" />
        
        <meta name="robots" content="index, follow" />
        
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://whatquiz.co.kr/guide/dokseo" />
        <meta property="og:title" content="교과세특 독서활동 추천 | 과목별 추천도서" />
        <meta property="og:description" content="과목별 세특 연계 추천도서와 기재 예시 문장." />
        <meta property="og:image" content="https://whatquiz.co.kr/og-image-whatquiz-2025.png?v=20260210" />
        <meta property="og:locale" content="ko_KR" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "교과세특 독서활동 추천 - 과목별 추천도서 모음",
            "description": "세특 연계를 위한 과목별 추천도서와 기재 예시",
            "author": { "@type": "Organization", "name": "왓퀴즈" },
            "publisher": { "@type": "Organization", "name": "왓퀴즈" },
            "datePublished": "2026-02-05",
            "dateModified": "2026-02-05"
          })}
        </script>
      </Helmet>

      <div style={{ 
        fontFamily: 'var(--whatquiz-font-family)',
        backgroundColor: '#fff',
        minHeight: '100vh'
      }}>
        {/* 히어로 */}
        <section style={{
          padding: '80px 20px 60px',
          textAlign: 'center',
          background: 'linear-gradient(180deg, #fef3c7 0%, #fff 100%)'
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <span style={{
              display: 'inline-block',
              padding: '6px 16px',
              backgroundColor: '#fde68a',
              color: '#92400e',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: '600',
              marginBottom: '16px'
            }}>
              세특 연계 추천도서
            </span>
            
            <h1 style={{
              fontSize: 'clamp(26px, 5vw, 40px)',
              fontWeight: '800',
              color: '#111',
              lineHeight: '1.3',
              marginBottom: '20px'
            }}>
              교과세특<br />
              <span style={{ color: '#d97706' }}>독서활동 추천</span>
            </h1>
            
            <p style={{
              fontSize: '17px',
              color: '#64748b',
              lineHeight: '1.7',
              marginBottom: '32px'
            }}>
              과목별 추천도서 & 세특 연계 문장 예시<br />
              <strong>바로 활용 가능한 기재 예시 포함</strong>
            </p>
          </div>
        </section>

        {/* 과목 선택 */}
        <section style={{
          padding: '40px 20px',
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#111',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            과목 선택
          </h2>

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            justifyContent: 'center',
            marginBottom: '40px'
          }}>
            {subjects.map((subj) => (
              <button
                key={subj}
                onClick={() => setSelectedSubject(subj)}
                style={{
                  padding: '10px 20px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: selectedSubject === subj ? '#fff' : '#374151',
                  backgroundColor: selectedSubject === subj ? '#d97706' : '#f1f5f9',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                {subj}
              </button>
            ))}
          </div>

          {/* 도서 목록 */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}>
            {currentBooks?.map((book, idx) => (
              <div key={idx} style={{
                padding: '24px',
                backgroundColor: '#f8fafc',
                borderRadius: '16px',
                border: '1px solid #e2e8f0'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '16px',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div>
                    <h3 style={{
                      fontSize: '18px',
                      fontWeight: '700',
                      color: '#111',
                      marginBottom: '4px'
                    }}>
                      {book.title}
                    </h3>
                    <p style={{
                      fontSize: '14px',
                      color: '#64748b',
                      margin: 0
                    }}>
                      저자: {book.author}
                    </p>
                  </div>
                  <span style={{
                    padding: '4px 12px',
                    backgroundColor: book.level === '상' ? '#fee2e2' : book.level === '중' ? '#fef3c7' : '#d1fae5',
                    color: book.level === '상' ? '#dc2626' : book.level === '중' ? '#d97706' : '#059669',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}>
                    난이도: {book.level}
                  </span>
                </div>

                <div style={{
                  padding: '12px',
                  backgroundColor: '#eff6ff',
                  borderRadius: '8px',
                  marginBottom: '16px'
                }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#1d4ed8' }}>교과 연계 포인트</span>
                  <p style={{ fontSize: '14px', color: '#1e40af', margin: '8px 0 0', lineHeight: '1.6' }}>
                    {book.connection}
                  </p>
                </div>

                <div style={{
                  padding: '16px',
                  backgroundColor: '#f0fdf4',
                  borderRadius: '8px',
                  borderLeft: '4px solid #22c55e'
                }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#16a34a' }}>세특 기재 예시</span>
                  <p style={{ fontSize: '14px', color: '#166534', margin: '8px 0 0', lineHeight: '1.8' }}>
                    {book.setak}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section style={{
          padding: '80px 20px',
          textAlign: 'center',
          background: 'linear-gradient(180deg, #fff 0%, #eff6ff 100%)'
        }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#111',
              marginBottom: '16px'
            }}>
              독서활동 세특,<br />
              <span style={{ color: '#3182f6' }}>AI가 자동 생성</span>
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#64748b',
              lineHeight: '1.7',
              marginBottom: '32px'
            }}>
              도서명만 입력하면<br />
              <strong>교과 연계 세특 문장 자동 작성</strong>
            </p>

            <button
              onClick={() => navigate('/create-saenggibu')}
              style={{
                padding: '16px 40px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#fff',
                backgroundColor: '#3182f6',
                border: 'none',
                borderRadius: '12px',
                cursor: 'pointer'
              }}
            >
              AI로 세특 작성하기
            </button>
          </div>
        </section>

        {/* 관련 가이드 */}
        <section style={{
          padding: '40px 20px',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#111',
            marginBottom: '16px'
          }}>
            관련 가이드
          </h3>
          
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px'
          }}>
            <Link to="/guide/setak-example" style={{
              padding: '12px 20px',
              backgroundColor: '#f1f5f9',
              borderRadius: '8px',
              color: '#334155',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              세특 예시 모음
            </Link>
            <Link to="/guide/saenggibu-2026" style={{
              padding: '12px 20px',
              backgroundColor: '#f1f5f9',
              borderRadius: '8px',
              color: '#334155',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              2026 생기부 기재요령
            </Link>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default DokseoGuidePage;
